import { render, staticRenderFns } from "./editgeonotification.vue?vue&type=template&id=51afd9fd&scoped=true"
import script from "./editgeonotification.vue?vue&type=script&lang=js"
export * from "./editgeonotification.vue?vue&type=script&lang=js"
import style0 from "./editgeonotification.vue?vue&type=style&index=0&id=51afd9fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51afd9fd",
  null
  
)

export default component.exports